import React from "react";

const InfiniteScrollText = ({ text = "Scrolling Text ", speed = 10 }) => {
  return (
    <div className="relative overflow-hidden w-[90vw] text-white h-14">
      <div
        className="flex space-x-96 animate-scroll"
        style={{ animationDuration: `${speed}s` }}
      >
        {/* Repeat the text multiple times for a seamless scroll */}
        {[...Array(4)].map((_, index) => (
          <span
            key={index}
            className="text-[15px] font-medium whitespace-nowrap"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default InfiniteScrollText;
